import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";

const FamilyDetail = () => {
  const { matricule } = useParams();

  const [familyMembers, setFamilyMembers] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    console.log(matricule);
    const fetchMember = async () => {
      try {
        const response = await fetch(
          "https://aga.esia.mg/api/auth/family-detail",
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
              "Content-Type": "application/json", // Specify content type
            },
            method: "POST",
            body: JSON.stringify({ matricule }), // Convert object to JSON string
          }
        );

        const parseRes = await response.json();
        if (parseRes.success === true) {
          // Log the retrieved data
          setFamilyMembers(parseRes.data);
        } else if (parseRes.message === "NOT AUTHORIZED") {
          localStorage.clear();
          navigate("/login");
        } else {
          console.log("Member not recognized");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchMember();
  }, [matricule]);

  const handleDelete = async (matricule) => {
    console.log("inside the handledelete: ", matricule);
    axios
      .delete("https://aga.esia.mg/api/auth/delete-member-by-id/" + matricule, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((response) => {
        if (response.data.success) {
          toast.success(response.data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <Layout>
      <div className="px-5 mt-3">
        <div className="d-flex justify-content-center">
          <h3 className="page-title">Family detail</h3>
        </div>
        <div className="mt-3">
          <table className="table">
            <thead>
              <tr>
                <th className="category">Photo</th>
                <th className="category">Matricule</th>

                <th className="category">Nom</th>
                <th className="category">Relationship</th>
                <th className="category">Telephone</th>
                <th className="category">Date de naissance</th>

                <th className="category">Societe</th>
                <th className="category">Status</th>
                <th className="category">Created At</th>
                <th className="category">Action</th>
                <th className="category">Admin</th>
              </tr>
            </thead>
            <tbody>
              {familyMembers.map((e) => (
                <tr key={familyMembers.member_id}>
                  <td>
                    <img
                      src={`http://localhost:3000/Images/Adherants/` + e.photo}
                      className="member_photo"
                      alt=""
                    />
                  </td>
                  <td>{e.matricule}</td>
                  <td>
                    {e.prenom} {e.nom}
                  </td>

                  <td>{e.family_relationship}</td>
                  <td>{e.telephone}</td>
                  <td>{e.date_de_naissance}</td>

                  <td>{e.societe}</td>
                  <td>{e.isactive === true ? "Active" : "Inactive"}</td>
                  <td>
                    {new Date(e.created_at).toLocaleDateString()}{" "}
                    {new Date(e.created_at).toLocaleTimeString()}
                  </td>
                  <td>
                    <Link to={`/member-detail/${e.matricule}`}>
                      <button
                        className="btn btn-secondary"
                        style={{
                          backgroundColor: "#005555",
                        }}
                      >
                        Detail
                      </button>
                    </Link>
                  </td>
                  <td>
                    <button
                      type="button"
                      onClick={() => handleDelete(e.matricule)}
                      className="btn btn-primary"
                      style={{
                        backgroundColor: "#bc0000",
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="d-flex">
          {/* <div style={{ marginRight: "10px" }}>
            <Link to={`/add-kid/${matricule}`}>
              <button className="btn btn-primary mr-2">Ajouter Enfant</button>
            </Link>
          </div> */}
          <div>
            <Link to={`/family-card/${matricule}`}>
              <button className="btn btn-primary">Afficher cartes</button>
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default FamilyDetail;
